







































































import { Icon } from '@alpha/ink'
import Subheader from '@/components/Subheader.vue'
import TemplateListItem from './TemplateListItem.vue'
import ClassicListItem from './ClassicListItem.vue'
import classicTestTypes, { ClassicTestType } from '@/utilities/classic-test-types'
import { Vue, Component } from 'vue-property-decorator'
import store from '@/store'
import * as graph from '@shared/types/graphql'
import loadingGif from '@/assets/img/loading.gif'
import api from '@/api'
import { camelCaseTitle } from '@/utilities/v-track-directive'

@Component({
  components: {
    Icon,
    Subheader,
    TemplateListItem,
    ClassicListItem
  }
})
export default class Picker extends Vue {
  show = {
    classicList: false,
    templateList: true
  }

  templates: graph.Template[] = []
  loadingGif = loadingGif

  trackingId (testTitle: string, template?: boolean) {
    return `addTest-pick${template ? 'Template' : 'Classic'}-${camelCaseTitle(testTitle)}`
  }

  get accountId () {
    return store.state.testCreation.workspace?.accountId
  }

  get testTypes () {
    return classicTestTypes
  }

  get featuredTestTemplates () {
    return this.templates.filter(template => {
      return template.created_by === 'System' && template.featured
    })
  }

  get customTestTemplates () {
    return this.templates.filter(template => {
      return template.created_by !== 'System' && template.featured
    })
  }

  created () {
    this.getTemplates()
  }

  async getTemplates () {
    if (!this.accountId) {
      throw new Error('Missing account id')
    }
    this.templates = await api.getTemplates(this.accountId)
  }

  toggleShown () {
    if (this.hasFeature('alphaClassic')) {
      this.show = {
        classicList: !this.show.classicList,
        templateList: !this.show.templateList
      }
    }
  }

  selectClassicTestType (type: ClassicTestType) {
    this.$emit('selectClassicTestType', type)
  }

  selectTemplate (template: graph.Template) {
    this.$emit('selectTemplate', template)
  }

  hasFeature (featureKey: string) {
    return store.getters.testCreation.currentWorkspaceHasFeature(featureKey)
  }
}
